<template>
  <AppPage class="home" :class="{ 'has-modal': isModalVisible }">
    <HomeTopDescription />
    <AppSocialLinks class="home__social" v-show="!$mq.isMobileOrTablet" />
    <AppMedia
      class="home__reel"
      :video="'https://pub-dfd09a1f367a4139805489ff686a8b0d.r2.dev/Projects/Reel/REEL_THUMB_WEB.mp4'"
      :video-webm="'https://pub-dfd09a1f367a4139805489ff686a8b0d.r2.dev/Projects/Reel/REEL_THUMB_WEB.webm'"
      :autoplay="false"
    >
    </AppMedia>
    <HomeTagline />
  </AppPage>
</template>

<script setup>
const { $eventBus, $Lenis } = useNuxtApp();
const brandRow = useBrandRow();
const isModalVisible = useAboutModal();
const route = useRoute();
const pageTitle = computed(() =>
  route.path === '/about' ? `About | ${meta.titleShort}` : meta.title
);

definePageMeta({
  alias: ['/about'],
  pageTransition: {
    name: 'page',
    mode: 'out-in',
  },
});

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: meta.description,
  ogDescription: meta.description,
});

onMounted(() => {
  // $Lenis.stop();
  brandRow.value = 'center';

  const onPageEnter = () => {
    // $Lenis.stop();
  };

  $eventBus.on('page:enter', onPageEnter);
});
</script>

<style lang="scss" scoped>
.home {
  min-height: var(--height);
  opacity: 0;
  overflow: hidden;
  perspective: 700px;

  .has-modal & {
    color: #000 !important;
  }
}

.home__reel {
  // height: var(--height);
  aspect-ratio: 16/9;
  margin: auto;
  position: fixed;
  z-index: layer(base);

  @include mqDown(desktop) {
    left: var(--offset);
    right: var(--offset);
    top: calc(var(--offset-double) + 20em);
    width: var(--col-2);
  }

  @include mq(desktop) {
    inset: 0;
    width: var(--col-2);
  }
}

.home__social {
  z-index: layer(overlay);
  position: absolute;
  padding: var(--offset);

  &:deep(.link-line) {
    transform: translateY(120%);
    transition-delay: calc(var(--index) * 0.1s);
  }

  &.is-animated {
    &:deep(.link-line) {
      transform: translateY(0%);
    }

    // &:deep(.link):hover {
    //   &:deep(.link-line) {
    //     color: red !important;
    //   }
    // }
  }
}
</style>
